import axios from 'axios';

const apiClient = axios.create({
  baseURL: 'https://issue-tracker.evenware.com/issue_tracker',
  headers: {
    'Content-type': 'application/json',
  }
});

export default apiClient;

// window.axios = axios
// axios.defaults.withCredentials = true
// axios.defaults.baseURL = 'http://localhost/vrs_vuejs_new/basic/';

// axios.interceptors.request.use(function(config){



//     return config;
// })